'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _HomeEduCenter = require('./HomeEduCenter.css');

var _HomeEduCenter2 = _interopRequireDefault(_HomeEduCenter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeEduCenter = (_dec = (0, _reactCssModules2.default)(_HomeEduCenter2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HomeEduCenter, _Component);

  function HomeEduCenter(props) {
    (0, _classCallCheck3.default)(this, HomeEduCenter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HomeEduCenter.__proto__ || (0, _getPrototypeOf2.default)(HomeEduCenter)).call(this, props));

    _this.state = {
      noheader: _this.props.noheader || false
    };
    return _this;
  }

  (0, _createClass3.default)(HomeEduCenter, [{
    key: 'render',
    value: function render() {
      var noheader = this.state.noheader;

      var hecIcn = require('../../../static/images/education-center-icon.svg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'hec-img-bckgrnd' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          noheader ? _react2.default.createElement('div', { styleName: 'bumper' }) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.eduCenter,
                title: 'Action center'
              },
              _react2.default.createElement('img', {
                src: hecIcn,
                styleName: 'hec-icn',
                alt: 'Action center'
              }),
              _react2.default.createElement(
                'h2',
                { styleName: 'hec-hl' },
                'Action center'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hec-tl' },
              'Learn how to work with your employer to ensure your retirement plan is sustainably invested.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'hec-btns' },
            _react2.default.createElement(
              'button',
              { styleName: 'hec-btn-out' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.eduCenterIndividual,
                  title: 'For employees'
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'hec-btn-in btn1' },
                  'For employees'
                )
              )
            ),
            _react2.default.createElement(
              'button',
              { styleName: 'hec-btn-out' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.eduCenterPlanAdmins,
                  title: 'For company 401(k) admins'
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'hec-btn-in btn2' },
                  'For company 401(k) admins'
                )
              )
            ),
            _react2.default.createElement(
              'button',
              { styleName: 'hec-btn-out' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.faqs,
                  title: 'FAQs'
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'hec-btn-in btn3' },
                  'FAQs'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return HomeEduCenter;
}(_react.Component), _class2.propTypes = {
  noheader: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = HomeEduCenter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeEduCenter/HomeEduCenter.js
// module id = 1387
// module chunks = 0